// @flow

import ReduxFormField from './reduxFormField';
import {
  DATE_VALIDATOR,
  EMAIL_VALIDATOR,
  PHONE_VALIDATOR,
  REQUIRED_VALIDATOR,
  SELECT_LENGTH_VALIDATOR,
} from './constants';

export {
  DATE_VALIDATOR,
  EMAIL_VALIDATOR,
  PHONE_VALIDATOR,
  REQUIRED_VALIDATOR,
  SELECT_LENGTH_VALIDATOR,
};

export type { Validators } from './constants';

export default ReduxFormField;
